import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { InfoProvider } from "@/context/InfoContext";
import { Header } from "@/components/site/Header";
import { Footer, WhatsAppFab } from "@/components/site/Footer";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import ManageBooking from "@/pages/ManageBooking";

const AuthPage = ({ children }) => (
  <section className="min-h-[70vh] flex items-center justify-center px-4 py-16" data-testid="auth-page">{children}</section>
);

const Private = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <InfoProvider>
          <div className="min-h-screen flex flex-col bg-white text-[#111111]">
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/reservar" element={<Booking />} />
                <Route path="/gestionar-reserva" element={<ManageBooking />} />
                <Route path="/mi-cuenta" element={<Private><Account /></Private>} />
                <Route path="/admin" element={<Private><Admin /></Private>} />
                <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
                <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <WhatsAppFab />
          </div>
          <Toaster position="top-center" richColors />
        </InfoProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
